// Módulo escolhido pelo hostname. O GED é reconhecido pelo primeiro rótulo ("ged." ou "ged-sand."), porque o domínio
// docgedsistemas contém o texto "ged"; os demais módulos seguem a regra de sempre (o hostname contém a sigla).
export type ModuleKey = 'sdp' | 'scp' | 'sge' | 'apm' | 'ser' | 'ouv' | 'sic' | 'ged' | '';

const GED_HOSTNAME = /^ged(-sand)?\./;

// Mesma ordem de avaliação da cadeia original
const MODULES_BY_SUBSTRING: ModuleKey[] = ['sdp', 'scp', 'sge', 'apm', 'ser', 'ouv', 'sic'];

export function resolveModuleKey(hostname: string): ModuleKey {
    const url = hostname.toLowerCase();
    if (GED_HOSTNAME.test(url)) return 'ged';
    return MODULES_BY_SUBSTRING.find((key) => url.includes(key)) ?? '';
}
